import styled from 'styled-components'
import { tokens } from '../../../styles/tokens'

const NoStyleButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font-size: inherit;
    color: inherit;
    cursor: pointer;
    outline: none;
    /* Mouse and touch clicks stay ring-free; keyboard focus gets the shared ring (globals.css) */
    &:focus-visible {
        outline: 2px solid ${tokens.focus.ring};
        outline-offset: ${tokens.focus.offset};
    }
    &:disabled {
        cursor: default;
    }
`
export default NoStyleButton
